<template>
    <div class="match-winner-container">
        <div v-for="item in betTypesMarkets" :key="item.betType">
            <div class="v-btn-toggle markets">
                <div v-for="market in item.markets" :key="market.marketId" class="mwMarkets">
                    <!--<div v-if="market.marketStatusId === 1" class="market-status">
                        {{market.marketName}}
                    </div>-->
                    <!--<div v-else class="market-status-suspended">
                        {{market.marketName}} - SUSPENDED
                    </div>-->
                    <v-btn v-scroll-to="'#betslipAnchor'" flat color="info" v-for="marketDetail in market.marketDetails" :class="[{'mwButton': true,'v-btn--active': marketDetailIsInBetSlip(marketDetail.marketDetailId),'oneMWMarket':(market.marketDetails.length ===1), 'twoMWMarkets':(market.marketDetails.length ===2), 'threeMWMarkets':(market.marketDetails.length === 3), 'disabledMarket':(marketDetail.marketDetailStatus !== 1 || market.marketStatusId !== 1 || marketDetail.marketDetailOdd === 0)}]" :key="marketDetail.marketDetailId" @click="addBet(marketDetail, market.marketName, market.marketId, market.marketStatusId)">
                        <market :class="{'selected-market': marketDetailIsInBetSlip(marketDetail.marketDetailId)}" :marketName="'Match Winner'" :marketDetail="marketDetail" :marketStatusId="market.marketStatusId"></market>
                        <!-- <div class="oddIncrease-enter-active" v-if="2>0"></div>
                        <div class="oddDecrease-enter-active" v-if="2>0"></div> -->

                        <transition name="oddIncrease">
                            <div @animationend="destroy(marketDetail)" v-if="marketDetail.css === 'oddIncrease'"></div>
                        </transition>
                        <transition name="oddDecrease">
                            <div @animationend="destroy(marketDetail)" v-if="marketDetail.css === 'oddDecrease'"></div>
                        </transition>
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Market from './Market.vue';
    import EventBetTypesMarketsApi from '../api/eventBetTypesMarkets';
    import { HubConnection } from "@aspnet/signalr";

    export default {
        name: 'MatchWinner',
        components: {
            Market
        },
        data() {
            return {
                betTypesMarkets: null,
            }
        },
        props: {
            connection: HubConnection,
            sport: String,
            tournament: String,
            eventId: String,
            eventName: String,
            eventTime: String,
            events: Array,
            expanded: Boolean,
        },
        watch: {
            expanded: function(newVal) {
                if (newVal) {
                    this.getMatchWinnerMarkets()
                }
                
            }
        },
        methods: {
            getMatchWinnerMarkets () {
                if (this.sport === "Basketball" || this.sport === "Handball" || this.sport === "Snooker" || this.sport === "Darts") {
                this.getEventBetTypesMarketsMatchResult(this.eventId);

            } else if (this.sport === "AmericanFootball") {
                this.getEventBetTypesMarketsAmericanFootball(this.eventId);
            } else if (this.sport === "IceHockey") {
                this.getEventBetTypesMarketsIceHockeyNoOT(this.eventId);
            }
            else {
                this.getEventBetTypesMarkets(this.eventId);
            }
            },
            getGroupConnection() {

            },

            destroy(marketDetail) {
                Vue.set(marketDetail, 'css', '')

            },
            marketDetailIsInBetSlip(marketDetailId) {
                return this.$store.getters.marketDetailIsInBetSlip(marketDetailId);
            },
            addBet(marketDetail, betTypeName, betTypeId, marketStatusId) {
                event.stopPropagation();
                if (marketDetail.marketDetailStatus === 1) {
                    //this.$store.dispatch('setShowBetSlipOddsAlert', false);
                    const bet = {
                        sport: this.sport,
                        tournament: this.tournament,
                        event: this.eventName,
                        time: this.eventTime,
                        betType: betTypeName,
                        css: '',
                        success: false,
                        error: false,
                        accepted: false,
                        errorMessage: '',
                        market: marketDetail.marketDetailName,
                        marketStatusId: marketStatusId,
                        marketDetailId: marketDetail.marketDetailId,
                        marketDetailStatus: marketDetail.marketDetailStatus,
                        betleg: {
                            eventId: this.eventId,
                            marketId: betTypeId,
                            marketDetailId: marketDetail.marketDetailId,
                            odds: parseFloat(marketDetail.marketDetailOdd),
                            stake: null,
                            betLegNumber: this.$store.getters.betSelectionCount + 1,
                            payout: null,
                            submitting: false
                        }
                    }
                    this.$store.dispatch('addBet', bet);
                }
            },
            toggleBetType() {
                this.getEventBetTypesMarkets(this.eventId, "match winner");
            },

            getEventBetTypesMarkets(eventId) {
                EventBetTypesMarketsApi.getEventBetTypesMarkets(eventId, "match winner", true)
                    .then(data => {
                        this.betTypesMarkets = data.responseObject;
                    })
            },
            getEventBetTypesMarketsMatchResult(eventId) {
                EventBetTypesMarketsApi.getEventBetTypesMarkets(eventId, "match result", true)
                    .then(data => {
                        this.betTypesMarkets = data.responseObject;
                    })
            },
            getEventBetTypesMarketsAmericanFootball(eventId) {
                EventBetTypesMarketsApi.getEventBetTypesMarkets(eventId, "win match in normal time", true)
                    .then(data => {
                        this.betTypesMarkets = data.responseObject;
                    })
            },
            getEventBetTypesMarketsFootballExtraTime(eventId) {
                EventBetTypesMarketsApi.getEventBetTypesMarkets(eventId, "et: winner", true)
                    .then(data => {
                        this.betTypesMarkets = data.responseObject;
                    })
            },
            getEventBetTypesMarketsIceHockeyNoOT(eventId) {
                EventBetTypesMarketsApi.getEventBetTypesMarkets(eventId, "match result (no ot)", true)
                    .then(data => {
                        this.betTypesMarkets = data.responseObject;
                    })
            },

            updateMarketDetail(updatedMarketDetail) {
                if (updatedMarketDetail !== null && this.betTypesMarkets && this.betTypesMarkets[0]) {
                    for (let market of this.betTypesMarkets[0].markets) {
                        //Check for entire market status from active to suspended
                        if (market.marketStatusId !== updatedMarketDetail.MarketStatus && market.marketId === updatedMarketDetail.MarketID) {
                            market.marketStatusId = updatedMarketDetail.MarketStatus;
                        }
                        for (let marketDetail of market.marketDetails) {
                            if (marketDetail.marketDetailId === updatedMarketDetail.MarketDetailID) {
                                if (marketDetail.marketDetailStatus !== updatedMarketDetail.Status) {
                                    marketDetail.marketDetailStatus = updatedMarketDetail.Status
                                }
                                if (updatedMarketDetail.Price > marketDetail.marketDetailOdd) {
                                    Vue.set(marketDetail, 'css', 'oddIncrease');
                                    marketDetail.marketDetailOdd = updatedMarketDetail.Price;
                                } else if (updatedMarketDetail.Price < marketDetail.marketDetailOdd) {
                                    Vue.set(marketDetail, 'css', 'oddDecrease');
                                    marketDetail.marketDetailOdd = updatedMarketDetail.Price;
                                }
                                else {
                                    Vue.set(marketDetail, 'css', '');
                                }
                            }
                        }
                    }
                }
            }
        },
        mounted() {
            
            if (this.connection) {
                this.connection.on("mw-rcv", (value) => {
                    if (value !== null) {
                        this.updateMarketDetail(JSON.parse(value));
                    }
                });
            }
            if(this.expanded) {
                this.getMatchWinnerMarkets();
            }
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .selected-market {
        color: #fff !important;
    }

    .match-winner-container {
        /*margin-top: 10px;*/
        width: 40%;
        padding-bottom: 8px;
        padding-top: 8px;
        padding-left: 50px;
    }

    .oddIncrease-enter-active {
        animation: increase 6s;
        position: absolute;
        right: 0rem;
        top: 0rem;
        border-top-right-radius: 5px;
    }

    .market-status, .market-status-suspended {
        padding-left: 10px;
        padding-top: 7px;
        padding-bottom: 6px;
        background-color: #696969;
        font-size: 15px;
    }

    @keyframes increase {
        100% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent #2ad100 transparent transparent;
        }

        80% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent transparent transparent transparent;
        }

        60% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent #2ad100 transparent transparent;
        }

        40% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent transparent transparent transparent;
        }

        20% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent #2ad100 transparent transparent;
        }

        0% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent transparent transparent transparent;
        }
    }

    .oddDecrease-enter-active {
        animation: decrease 6s;
        position: absolute;
        right: 0rem;
        bottom: 0rem;
        transform: rotate(90deg);
        border-top-right-radius: 5px;
    }

    @keyframes decrease {
        100% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent #f50000 transparent transparent;
        }

        80% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent transparent transparent transparent;
        }

        60% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent #f50000 transparent transparent;
        }

        40% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent transparent transparent transparent;
        }

        20% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent #f50000 transparent transparent;
        }

        0% {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent transparent transparent transparent;
        }
    }

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        .oddIncrease-enter-active {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent;
            bottom: 22px;
        }

        .oddDecrease-enter-active {
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent;
            top: 22px;
        }
    }

    @supports (-ms-ime-align:auto) {
        .oddIncrease-enter-active {
            transform: translateY(-9px);
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent;
        }

        .oddDecrease-enter-active {
            transform: translateY(9px) rotate(90deg);
            border-style: solid;
            border-width: 0 13px 13px 0;
            border-color: transparent;
        }
    }

    .theme--dark.v-btn.v-btn--disabled, .theme--dark.v-btn.v-btn--disabled .v-btn__loading, .theme--dark.v-btn.v-btn--disabled .v-icon {
        color: #fff !important;
        pointer-events: auto !important;
        cursor: not-allowed;
        opacity: 0.3 !important;
        background: transparent !important;
    }

    .v-btn--active:before, .v-btn:focus:before, .v-btn:hover:before {
        background-color: #585858;
    }

    .v-btn.v-btn--active {
        background-color: #643e94;
        border-right-color: #643e94 !important;
    }

    .markets {
        display: inline-block;
        width: 100%;
    }

    .info--text.v-btn {
        background-color: #555;
        color: #fff !important;
        margin: 6px 8px 0px 0px;
        flex: 1 0 auto;
        opacity: 1;
        position: relative;
    }

    .info--text.v-btn:hover, .info--text.v-btn.v-btn--active {
        background-color: none;
    }

    .theme--dark.v-btn-toggle, .v-btn-toggle--selected {
        background: none !important;
        box-shadow: none;
    }

    .disabledMarket {
        opacity: 1 !important;
        text-decoration: line-through !important;
        pointer-events: none;
        cursor: default !important;
    }


    .mwMarkets .threeMWMarkets {
        width: 33.33% !important;
        border-radius: 10px !important;
        flex-grow: 1 !important;
        max-width: calc(33.333% - 10px);
        margin: 0 2px !important;
        border: 1px solid #EEEEEE ;
        background-color: #fff;
        border-right: 1px solid #EEEEEE !important;
    }

    .mwMarkets .twoMWMarkets {
        width: 50% !important;
        border-radius: 10px !important;
        flex-grow: 1 !important;
        max-width: calc(50% - 10px);
        margin: 0 2px !important;
        border: 1px solid #EEEEEE !important;
        background-color: #fff;
    }

    .mwMarkets .oneMWMarket {
        width: 50% !important;
        border-radius: 10px !important;
        flex-grow: 1 !important;
        margin: 0 2px !important;
        max-width: calc(75% - 10px);
        border: 1px solid #EEEEEE !important;
        background-color: #fff;
    }

    .mwMarkets {
        display: flex;
        height: 50px !important;
    }

    .mwMarkets .threeMWMarkets:last-child {
        border-radius: 10px !important;
    }

    .mwMarkets .twoMWMarkets:last-child {
        border-radius: 10px !important;
    }

    .mwMarkets .oneMWMarket:last-child {
        border-radius: 10px !important;
    }

    @media (max-width: 960px) {
        .match-winner-container {
            width: 50%;
            padding-bottom: 20px;
            padding-top: 8px;
            padding-left: 20px;
            margin-bottom: 20px;
        }

        .mwMarkets {
            display: block;
            height: 49px !important;
        }

        .mwMarkets .threeMWMarkets {
            border: none !important;
            background-color: #f4f6fd ;
            border-radius: 5px !important;
        }

        .mwMarkets .twoMWMarkets {
            border: none !important;
            background-color: #f4f6fd ;
            border-radius: 5px !important;
        }

        .mwMarkets .oneMWMarket {
            border: none !important;
            background-color: #f4f6fd ;
            border-radius: 5px !important;
        }

        .mwMarkets .threeMWMarkets:last-child {
            border-radius: 5px !important;
        }

        .mwMarkets .twoMWMarkets:last-child {
            border-radius: 5px !important;
        }

        .mwMarkets .oneMWMarket:last-child {
            border-radius: 5px !important;
        }
        
    }
</style>
